<template>
  <v-form :submit="submitUpdate">
    <v-row density="compact">
      <v-col cols="12" md="3" sm="6">
        <v-text-field
                      label="Nome"
                      :disabled="requestingApi"
                      v-model="editUser_local.name"
                      :rules="rules.name"></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-text-field
                      label="E-mail"
                      :disabled="requestingApi"
                      v-model="editUser_local.email"
                      :rules="rules.email"></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-text-field
                      label="Senha"
                      :disabled="requestingApi"
                      v-model="editUser_local.password"
                      :rules="rules.password"
                      :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append-inner="showPassword = !showPassword"
                      :type="showPassword ? 'text' : 'password'"></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-text-field
                      label="Repita a senha"
                      :disabled="requestingApi"
                      v-model="editUser_local.password2"
                      :rules="rules.password2"
                      :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append-inner="showPassword = !showPassword"
                      :type="showPassword ? 'text' : 'password'"></v-text-field>
      </v-col>
      <v-col v-if="user.id != editUser?.id" cols="12" sm="6">
        <v-autocomplete
                        label="Nível de acesso"
                        v-model="editUser_local.access_level"
                        item-title="label"
                        item-value="value"
                        :items="accessLevels">
          <template v-slot:no-data>
            <div class="px-4">Digite sua busca</div>
          </template></v-autocomplete>
      </v-col>
      <v-col v-if="user.id != editUser?.id" cols="12" sm="6">
        <v-autocomplete
                        label="Status do acesso"
                        v-model="editUser_local.status"
                        item-title="label"
                        item-value="value"
                        :items="$USER_STATUSES">
          <template v-slot:no-data>
            <div class="px-4">Digite sua busca</div>
          </template></v-autocomplete>
      </v-col>
      <v-col v-if="editUser_local.img" cols="1" class="text-center">
        <v-avatar
                  class="mx-auto"
                  :image="editUser_local.img" />
      </v-col>
      <v-col :cols="editUser_local.img ? 3 : 4">
        <UploadFile
                    accept-type="image/png, image/jpeg, image/bmp"
                    icon="mdi-image"
                    :fileType="$FILE_TYPE.group_image"
                    :userId="user.id"
                    @uploaded="uploadedImage" />
      </v-col>
      <v-col cols="8">
        <v-text-field
                      label="URL do avatar"
                      v-model="editUser_local.img"></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit"><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import UploadFile from "./UploadFile.vue";
import api from '@/services'
import functions from '@/services/Functions'
export default {
  components: { UploadFile },
  props: {
    user: Object,
    editUser: Object,
    legalPersonId: Number,
  },
  data() {
    return {
      requestingApi: null,
      editUser_local: {},
      showPassword: false,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        name: [(v) => !!v || "Campo obrigatório"],
        email: [
          (v) => !!v || "Campo obrigatório",
          (v) => /.+@.+/.test(v) || "E-mail inválido",
        ],
        password: [
          (value) => {
            // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
            const pattern = /^(?=.{8,})/;
            return (
              pattern.test(value) ||
              "A senha precisa conter pelo menos 8 caracteres"
            );
          },
        ],
        password2: [
          (v) =>
            this.editUser_local.password == this.editUser_local.password2 ||
            "A confirmação da senha deve ser igual a senha",
        ],
      },
    };
  },
  created() {
    var vm = this;
    vm.editUser_local = vm.editUser || vm.generateEmpty();
  },
  mounted() { },
  activated() { },
  methods: {
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      vm.editUser_local.legal_person_id = vm.legalPersonId;
      return new Promise((resolve, reject) => {
        api.user
          .update(vm.editUser_local)
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    uploadedImage(image) {
      var vm = this;
      vm.editUser_local.img = image.path;
    },
    generateEmpty() {
      return {
        name: null,
        email: null,
        password: null,
        status: 1,
        access_level: 0,
        img: null,
      };
    },
  },
  computed: {
    accessLevels() {
      var vm = this
      let _lstResult = []
      let _userAccess = vm.user?.access_level || 0
      vm.$USER_ACCESS_LEVELS.forEach(ac_lvl => {
        if (ac_lvl.value <= _userAccess) {
          _lstResult.push(ac_lvl)
        }
      });
      return _lstResult
    }
  },
  watch: {
    editUser(newVal) {
      this.editUser_local = newVal || this.generateEmpty();
    },
  },
};
</script>